<template>
    <default>
        <div class="relative px-4 sm:px-6 lg:px-8">
            <div class="text-lg max-w-prose mx-auto">
                <h1 class="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    Pourquoi?
                </h1>
            </div>
            <div class="mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
                <p>Ça y est! Vous avez réservé votre nom de domaine @votreorganisation.ca et vous avez de nouvelles adresses de courriels pour votre entreprise. Par contre, vous aimeriez bien avoir un site Web, mais vous manquez de temps ou d’argent pour en construire un. Vous avez encore une page d'accueil en construction, en 15 minutes changez tout ça par une page qui sera attirer Google.</p>
                <p>Saviez-vous que beaucoup de contacts à qui vous allez écrire vont copier-coller votre nom de domaine dans un navigateur après avoir reçu un courriel de vous et ce, pour connaître vos coordonnées, ou simplement pour établir une crédibilité. Si vous ne vous occupez pas de votre image sur le Web qui le fera?</p>
                <figure>
                    <img
                        class="w-full rounded-lg"
                        src="images/firefox.png"
                        alt=""
                        width="1310"
                        height="873"
                    />
                    <figcaption>Imaginez vos clients qui tombent sur ceci.</figcaption>
                </figure>
                <p>Non, ni votre hébergeur, ni le registraire de votre nom de domaine ne vous fournit de page Web. C’est à vous à vous en occuper. C’est ici que nous entrons en jeux. Nous vous offrons gratuitement une page Web. Entrez simplement 5 informations de base sur votre organisation et nous vous enverrons une page Web par courriel avec les instructions à donner à votre hébergeur.</p>
                <p>Pas encore convaincu? Votre Webmestre vous as dit (sans rire) que votre site Web sera prêt dans 2 mois? Vous n’avez pas besoin de site Web? Erreur. Ne pas avoir ne serait-ce qu’une page Web, est comme si vous payiez pour une annonce vide dans les Pages Jaunes. Google ne peux pas vous trouver et vos clients non plus!</p>
                <figure>
                    <img
                        class="w-full rounded-lg"
                        src="images/pages-jaune.png"
                        alt=""
                        width="1310"
                        height="873"
                    />
                </figure>
            </div>
        </div>
    </default>
</template>

<script>
    import Alert from '@/components/ui/Alert.vue';
    import Default from '@/layouts/Default.vue';

    export default {
        components: {
            Default,
            Alert,
        },

        props: {
            errors: Object,
        },

        data() {
            return {
                form: {
                    name: null,
                    email: null,
                },
            };
        },

        methods: {
            submit() {
                this.$inertia.post(this.$route('home'), this.form);
            },
        },
    };
</script>
